import { graphql } from "gatsby"
import React from "react"

import CoreEmbedMolecule from "@knowit-alma/common/src/components/molecules/CoreEmbed/CoreEmbed"

const CoreEmbed = ({ captionText, providerNameSlug, type, url }) => {
  return (
    <CoreEmbedMolecule
      captionText={captionText}
      providerNameSlug={providerNameSlug}
      type={type}
      url={url}
    />
  )
}

export const query = graphql`
  fragment CoreEmbed on WpBlockCoreEmbed {
    __typename
    captionText
    providerNameSlug
    type
    url
  }
`

export default CoreEmbed
